/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const clientPortalSlice = createSlice({
  name: "isClientPortal",
  initialState: false,
  reducers: {
    setIsClientPortal: (_, action) => action.payload
  }
});

export const { setIsClientPortal } = clientPortalSlice.actions;
export default clientPortalSlice.reducer;
